module.exports = __webpack_public_path__ + "static/img/h_0_bak.540e6a6f.jpg";